import { v4 as uuid } from 'uuid';

import * as types from './types';
import { updateApplication } from "./applicationActions";

export const updateProfessionalInfo = (updates) => {
  return {
    type: types.UPDATE_PROFESSIONAL_INFO,
    updates
  }
};

export const addDegree = () => {
  const newDegree = {
    id: uuid()
  };
  return {
    type: types.ADD_DEGREE,
    newDegree
  }
};

export const removeDegree = (degreeId) => {
  return {
    type: types.REMOVE_DEGREE,
    degreeId
  }
};

export const updateDegree = (degreeId, updates) => {
  return {
    type: types.UPDATE_DEGREE,
    degreeId,
    updates
  }
};

export const addLicense = () => {
  const newLicense = {
    id: uuid()
  };
  return {
    type: types.ADD_LICENSE,
    newLicense
  }
};

export const removeLicense = (licenseId) => {
  return {
    type: types.REMOVE_LICENSE,
    licenseId
  }
};

export const updateLicense = (licenseId, updates) => {
  return {
    type: types.UPDATE_LICENSE,
    licenseId,
    updates
  }
};

export const addCertificate = () => {
  const newCertificate = {
    id: uuid()
  };
  return {
    type: types.ADD_CERTIFICATE,
    newCertificate
  }
};

export const removeCertificate = (certificateId) => {
  return {
    type: types.REMOVE_CERTIFICATE,
    certificateId
  }
};

export const updateCertificate = (certificateId, updates) => {
  return {
    type: types.UPDATE_CERTIFICATE,
    certificateId,
    updates
  }
};

export const saveProfessionalInfo = (professional) => {
  return updateApplication({professional});
};